var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-toolbar',[_c('v-btn',{on:{"click":function($event){return _vm.updateTokens()}}},[_vm._v("Update Tokens")])],1),_c('organisations',{attrs:{"organisations":_vm.organisations,"organisationtypes":_vm.organisationTypes},on:{"organisationChange":function($event){return _vm.getOrganisations()}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }